<template>
    <div id="dropzone-root" class="gk-vue-dropzone">
        <canvas id="ocr-canvas" style="display: none;"></canvas>
        <div v-show="!file && !fileUrl" id="dropzone" class="dropzone dz-clickable" :class="file ? 'dropzone-border-none dz-started dz-max-files-reached' : 'dropzone-border'">
            <div class="dropzone-hint">
                <font-awesome-icon icon="fa-solid fa-upload" class="dropzone-hint-icon" />
                <span class="dropzone-hint-text" v-translate>Click or drag a file to add it</span>
            </div>
        </div>
        
        <div v-show="fileType == 'image'" id="dropzonePreview" class="dropzone dz-default dz-file-preview dropzone-border-none dropzone-preview dropzone-preview-image">
            <ImageViewer :zoomable="zoomable" :file-path="preloaded_file" ref="previewImage" />
        </div>


        <GkPDFViewer 
            v-if="showMobileViewer && fileType === 'pdf'"
            :item-pdf="computed_file_url"
        />
        <template v-if="!showMobileViewer">
            <iframe 
                v-show="fileType == 'pdf'"
                ref="previewPdf"
                :key="fileUrl"
                class="dropzone dz-clickable dz-default dz-file-preview dropzone-border-none dropzone-preview"
                :src="(fileType == 'pdf') ? computed_file_url : ''"
            />
        </template>


        
        <div v-show="fileType == 'other'" class="dropzone dz-clickable dz-default dz-file-preview dropzone-border-none dropzone-preview preview-misc">
            <div class="misc-filetype-icon d-flex flex-column">
                <font-awesome-icon icon="fa-regular fa-file" />
                <div v-if="fileUrl && !file" class="filename pt-2">
                    {{ getLoadedFileName(fileUrl) }}
                </div>
                <div v-if="file" class="filename pt-2">{{ file.name }}</div>
            </div>
        </div>

        <div class="dropzone-file-actions" :class="{ visible: showFileActions}">
            <GekkoButton 
                v-show="!onlyChange && (file || fileUrl)"
                @click="removeImage"
                :text="$gettext('Remove file')" 
                icon="fa-solid fa-trash-can"
                class="text-danger"
                variant="link"
                size="sm"
            />
            <GekkoButton 
                v-show="onlyChange && (file || fileUrl) && !disableEdit"
                id="click-change-image"
                :text="$gettext('Replace file')" 
                icon="fa-solid fa-upload"
                class="text-info"
                variant="link"
                size="sm"
            />
            <GekkoButton 
                v-show="fileUrl && !disableDownload"
                @click="downloadFile(fileUrl)"
                :text="$gettext('Download')" 
                icon="fa-solid fa-download"
                class="text-info"
                variant="link"
                size="sm"
            />
        </div>
    </div>
</template>

<script>
    import customAxios from "../store/services/axiosConfig";
    import GekkoButton from "@/components/GekkoButton";
    import ImageViewer from "@/components/ui/ImageViewer";
    import GkPDFViewer from '@/components/invoices/ui/GkPDFViewer'
    import pdfviewer from "@/mixins/pdfviewer";

    export default {
        name: "VueDropzone",
        mixins: [pdfviewer],
        components: { GekkoButton, ImageViewer, GkPDFViewer },
        props: {
            preloaded_file: {
                type: String,
                default: null,
            },
            upload_url: {
                type: String,
                default: null,
            },
            allowedFiles: {
                type: String,
                default: "img",
            },
            disableEdit: {
                type: Boolean,
                default: () => false
            },
            disableRemove: {
                type: Boolean,
                default: () => false
            },
            disableDownload: {
                type: Boolean,
                default: () => false
            },
            image_field_name: String,
            delete_url: String,
            onlyChange: {
                type: Boolean,
                default: false
            },
            zoomable: {
                type: Boolean,
                default: true
            }
        },
        data () {
            return {
                file: null,
                fileType:'',
                fileUrl: null,
                myDropzone: null,
                initializing: false,
            }
        },
        computed: {
            preloaded_file_type() {
                return window.getFileType(this.preloaded_file);
            },
            computed_file_type() {
                return this.fileType;
            },
            computed_file_url() {
                return this.fileUrl;
            },
            showFileActions () {
                return (
                    (!this.onlyChange && (this.file || this.fileUrl)) || 
                    (this.onlyChange && (this.file || this.fileUrl) && !this.disableEdit) || 
                    (this.fileUrl)
                )
            }
        },
        watch: {
            preloaded_file: function (newVal, oldVal) {
                this.initDropzone();
                if (oldVal !== newVal) {
                    this.fileType = window.getFileType(newVal);
                    this.fileUrl = newVal;

                    let mockFile = {name: "this.$gettext('Filename')", size: 12345,mock:true};
                    let callback = null; // Optional callback when it's done
                    let crossOrigin = null; // Added to the `img` tag for crossOrigin handling
                    let resizeThumbnail = false; // Tells Dropzone whether it should resize the image first
                    this.myDropzone.displayExistingFile(mockFile, this.fileUrl, callback, crossOrigin, resizeThumbnail);
                }
                
            },
            upload_url: function (newVal, oldVal) {
                if (oldVal !== newVal && this.myDropzone) {
                    this.myDropzone.options.url = newVal;
                }
            }
        },
        mounted() {
            this.initDropzone();
            if (this.preloaded_file) {
                this.fileType = window.getFileType(this.preloaded_file);

                this.fileUrl = this.preloaded_file;

                let mockFile = {name: "this.$gettext('Filename')", size: 12345,mock:true};
                let callback = null; // Optional callback when it's done
                let crossOrigin = null; // Added to the `img` tag for crossOrigin handling
                let resizeThumbnail = false; // Tells Dropzone whether it should resize the image first
                this.myDropzone.displayExistingFile(mockFile, this.fileUrl, callback, crossOrigin, resizeThumbnail);
            }
        },
        methods: {
            initDropzone () {
                if (!this.myDropzone && !this.initializing) {
                    this.initializing = true;
                    this.initialize();
                }
            },
            downloadFile(fileUrl){
                window.open(fileUrl);
            },
            initialize(){

                var file_types = "*/*";
                if(this.allowedFiles === "img"){
                    file_types = "image/*";
                } else if (this.allowedFiles === "all") {
                    file_types = "image/*, application/*, application/pdf";
                }
                const accessToken = localStorage.getItem('access_token')
                var options = {
                    method: "patch",
                    thumbnailWidth: null,
                    acceptedFiles: file_types,
                    thumbnailHeight: null,
                    thumbnailMethod: 'contain',
                    maxFiles: 1,
                    // previewsContainer: '#dropzonePreview',
                    clickable: ['#dropzone', '#click-change-image',],
                    headers: {
                        // 'X-CSRFToken': document.head.querySelector("[name~=csrftoken][content]").content
                        'Authorization': `Bearer ${accessToken}`
                    },
                };
                if (this.upload_url) {
                    options['url'] = this.upload_url;
                } else {
                    options['url'] = "www.com"; //this may not be empty or the dropzone will not initialize!!!
                    options['autoProcessQueue'] = false;
                }

                window.Dropzone.autoDiscover = false;   //Disable autodiscover because we are initializing Dropzone on the next line.
                this.myDropzone = new window.Dropzone(this.$el, options);

                this.myDropzone.on("maxfilesexceeded", function (file) {
                    this.removeAllFiles();
                    this.addFile(file);
                });

                this.myDropzone.on("addedfile", (file) => {
                    // To avoid previewing not img files on settings avatar dropzone
                    if(this.allowedFiles === "img"){
                        if(file.mock){
                            return false;
                        }
                        if(!file.type.includes('image/')){
                            return false;
                        }
                    }
                    if(!file.mock){
                        if (this.file) {
                            this.removeImage();
                            // this.myDropzone.removeFile(this.file);
                        }
                        this.file = file;
                        this.fileType = window.getFileType(this.file);
                        if(this.fileType === 'pdf'){
                            let reader = new FileReader();
                            reader.readAsDataURL(this.file);
                            reader.onloadend = () => {
                                this.fileUrl = reader.result;
                                if (!this.showMobileViewer) {
                                    this.$refs.previewPdf.src = this.fileUrl;
                                }
                            };
                        }
                        this.$emit('change', this.file)
                    }
                });
                this.myDropzone.on('thumbnail', (file, dataURL) => {
                    if(this.fileType == 'image') {
                        // this.$refs.previewImage.src = dataURL;
                        this.$refs.previewImage.updateFilePath(dataURL)
                    }
                });
                this.myDropzone.on("sending", (file, xhr, formData) => {
                    formData.append(this.image_field_name, file);
                });

            },
            getLoadedFileName (path) {
                if(!path){
                    return;
                }
                const fileExtensionPattern = /[^/\\&?]+\.\w{3,4}(?=([?&].*$|$))/igm
                if(!path.match(fileExtensionPattern)){
                    return ''
                }
                const file_extension_match = path.match(fileExtensionPattern)[0];
                return file_extension_match;
            },
            removeImage (){
                this.file = null;
                this.fileType = null;
                this.fileUrl = null;
                this.myDropzone.removeAllFiles();
                this.$emit('change', '');
                if (this.delete_url) {
                    customAxios.delete(this.delete_url);
                } else if(this.upload_url){
                    var data = {};
                    data[this.image_field_name] = null;
                    customAxios.patch(this.upload_url, data);
                }
            },
            openFileDialog () {
                if (this.myDropzone && this.myDropzone.hiddenFileInput) {
                this.myDropzone.hiddenFileInput.click()
                }
            }
        }
    }
</script>

<style lang="scss">
    .gk-vue-dropzone {
        .gk-pdf-viewer {
            height: calc(100% - 40px); // actions + margin
        }
    }
    #dropzone-root {
        height: 100%;
        .preview-misc {
            display: flex;
            align-items: center;
            justify-content: center;
        }
        .misc-filetype-icon {
            font-size: 60px;
            color: $colorBrand;
            .filename {
                font-size: 16px;
                color: black;
            }
        }
        .dz-preview { display: none; }
        .dropzone .dz-preview:hover .dz-image img {
            filter: none;
            transform: none;
        }
        .dropzone-preview, .dz-preview{
            height: 100%;
        }
        .dropzone-preview {
            text-align: center;
            width: 100%;
            height: calc(100% - 40px); // actions + margin
        }
        .dz-preview, .dz-image {
            width: 100%;
            height: 100%;
        }
        .dz-image {
            position: relative;
            img {
                position: absolute;
                top: 0;
                left: 0;
                object-fit: contain;
                width: 100%;
                height: 100%;
            }
        }
        .dropzone-preview-image {
            position: relative;
            img.dropzone-img {
                position: absolute;
                top: 0;
                left: 0;
                object-fit: contain;
                // object-position: left;
                width: 100%;
                height: 100%;
            }
        }
        .dropzone-border {
            border-radius: $radiusSm;
            border: 4px dashed rgba(55, 160, 205, 0.3) !important;
            border-image: none;
            width:100%;
            height: 100%;
        }

        .dropzone-border-none {
            margin: 0;
            border-radius: $radiusSm;
            border: 0 dashed rgba(55, 160, 205, 0.3);
            border-image: none;
            padding: 0 !important;
            margin-left: 0 !important;
        }

        .dropzone {
            background: white;
            margin-left: auto;
            margin-right: auto;
            display: block;
        }

        .dropzone .dz-preview {
            margin: 0;
        }

        .dropzone .dz-preview .dz-image {
            width: 100%;
            height: 100%;
        }

        .dropzone .dz-preview .dz-image img {
            cursor: pointer !important;
            width: 100%;
            height: 100%;
        }

        .dz-preview .dz-image:empty {
            border: none;
        }
        .dz-size{
            display: none;
        }
        .dz-filename {
            display: none;
        }
        .dropzone-hint {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            height: 100%;
            width: 100%;
            cursor: pointer !important;
            color: $colorBlue;
            .dropzone-hint-icon {
                font-size: 54px;
                margin-bottom: 10px;
            }
            .dropzone-hint-text{
                cursor: pointer !important;
                font-family: DINNextLTPro-Medium, sans-serif;
                font-size: 18px;
            }
        }
    }

</style>
<style lang="scss" scoped>
    .dropzone-file-actions.visible {
        display: flex;
        margin-top: 10px;
        height: 30px;
    }
    .download-file{
        color:$colorBlue;
        justify-content: space-between;
        margin-top: 5px;
    }
</style>